import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { ConsumerLoanParameter } from '../domain/types/ConsumerLoanParameter';

const useArnFromPath = (): string | undefined => {
    const params = useParams();

    const applicationReferenceNumber = useMemo(
        () => params[ConsumerLoanParameter.applicationReferenceNumber],
        [params],
    );

    return applicationReferenceNumber;
};

export default useArnFromPath;
